const NewsPreviewContnet = props => {
  const { content, postImage } = props;

  const sanitizeAnchors = html => {
    // Create a temporary DOM to manipulate links
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const anchors = tempDiv.querySelectorAll("a");

    anchors.forEach(anchor => {
      const href = anchor.getAttribute("href");

      if (href?.includes("finance.yahoo.com/")) {
        anchor.removeAttribute("href");
      } else {
        anchor.setAttribute("target", "_blank");
        anchor.setAttribute("rel", "noopener noreferrer");
      }
    });

    return tempDiv.innerHTML;
  };

  const renderNode = (node, index) => {
    if (node.type === "text") {
      const Tag = node.tagName || "p";
      const sanitizedContent = sanitizeAnchors(node.content);

      return (
        <Tag
          key={index}
          dangerouslySetInnerHTML={{ __html: sanitizedContent }}
        />
      );
    } else if (node.type === "heading") {
      const Tag = node.tagName || "h3";
      return (
        <Tag key={index} dangerouslySetInnerHTML={{ __html: node.content }} />
      );
    } else if (node.type === "list") {
      const ListTag = node.bulletedList ? "ul" : "ol";
      return (
        <ListTag key={index}>
          {node.items.map((item, i) => (
            <li key={i}>{item.val.map((v, j) => renderNode(v, j))}</li>
          ))}
        </ListTag>
      );
    } else if (node.type === "image") {
      return node.size?.original?.url &&
        node.size?.original?.url !== postImage ? (
        <img
          key={index}
          src={node.size?.original?.url}
          alt={node.alt || ""}
          className="ml-auto mr-auto"
        />
      ) : null;
    } else {
      const Tag = node.tagName || "div";
      return (
        <Tag key={index} dangerouslySetInnerHTML={{ __html: node.content }} />
      );
    }
  };
  const ContentRenderer = ({ data }) => {
    return <div>{data?.map((node, i) => renderNode(node, i))}</div>;
  };
  return (
    <div className="event-page-news-content">
      {postImage ? (
        <img src={postImage} alt="" className="ml-auto mr-auto" />
      ) : null}
      <ContentRenderer data={content} />
    </div>
  );
};

export default NewsPreviewContnet;
